import axios from 'axios'

//const url = window.location.origin + '/ipa'
const url = 'http://localhost:9092/ipa'

const service = axios.create({
  baseURL: url,
  timeout: 120000
})
service.defaults.timeout = 120000
service.interceptors.request.use(
  config => {
    config.headers['Access-Control-Allow-Origin'] = '*'
    config.headers['Access-Control-Allow-Credentials'] = 'true'
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => response,
  error => {
    return Promise.reject(error)
  }
)

export default service
